import vars from '../helpers';

const $items = $('.menu__item');

let disableCheck = false;

$('.header__burger').on('click', (e) => {
	e.preventDefault();
	disableCheck = true;
	// vars.saveScrollPosition();
	$('.menu').scrollTop(0);
	vars.$html.addClass('is-show-menu');
	// setTimeout(() => {
	// 	vars.$html.addClass('is-scroll-disabled');
	// }, 400);
});

$('.menu__close').on('click', (e) => {
	e.preventDefault();
	disableCheck = false;
	vars.$html.removeClass('is-show-menu');
	// vars.$html.removeClass('is-scroll-disabled');
	// vars.restoreScrollPosition();
});

$items.on('click', (e) => {
	let offset = 0;

	if (vars.isMobile()) {
		offset = 0 - $('.header').outerHeight() - 15;
	}

	e.preventDefault();
	disableCheck = false;
	vars.$html.removeClass('is-show-menu');
	// vars.$html.removeClass('is-scroll-disabled');
	// vars.restoreScrollPosition();
	vars.scrollTo($($(e.currentTarget).attr('href')), 500, offset);
});

vars.$window.on('scroll', () => {
	if (vars.isMobile() && !disableCheck) {
		$items.removeClass('is-active');

		$items.each((index, item) => {
			const $item = $(item);

			const $target = $($item.attr('href'));

			if (
				vars.$window.scrollTop() + vars.$window.outerHeight() / 2 > $target.offset().top
				&&
				vars.$window.scrollTop() + vars.$window.outerHeight() / 2 < $target.offset().top + $target.outerHeight()
			) {
				$item.addClass('is-active');
			}
		});
	}
});
